import { Component, Input } from '@angular/core';
@Component({
  selector: 'payarc-gauge',
  templateUrl: './payarc-gauge.component.html',
  styleUrls: ['./payarc-gauge.component.css'],
  standalone: false
})
export class PayarcGaugeComponent {
  @Input() value = 0;
  @Input() max = 1;
  @Input() limit = 0;        // threshold marker (0 = none)
  @Input() label?: string;
  @Input() unit = '%';
  readonly L = Math.PI * 50;
  private clamp(f: number) { return Math.max(0, Math.min(1, f)); }
  get frac() { return this.clamp(this.max ? this.value / this.max : 0); }
  get dash() { return this.frac * this.L; }
  get color() {
    if (this.limit > 0 && this.value >= this.limit) { return 'var(--pa-coral)'; }
    if (this.limit > 0 && this.value >= this.limit * 0.7) { return 'var(--pa-amber)'; }
    return 'var(--pa-mint)';
  }
  get tick() {
    const f = this.clamp(this.max ? this.limit / this.max : 0);
    const th = Math.PI * (1 - f);
    const c = Math.cos(th), s = Math.sin(th);
    return { x1: 60 + 44 * c, y1: 60 - 44 * s, x2: 60 + 56 * c, y2: 60 - 56 * s };
  }
  get displayValue() { return this.value + this.unit; }
}
